import React from 'react';
import UserEditablePopup from '../userEditablePopup/UserEditablePopup';
import PwdEditablePopup from '../pwdEditablePopup/PwdEditablePopup';

export const columnSetter = (dataReloadFunc, deleteFunc, auths) => {
  const columns = [
    {
      Header: '불출정보',
      columns: [
        {
          Header: <div></div>,
          accessor: 'index',
        },
        {
          Header: '아이디',
          accessor: 'userId',
        },
        {
          Header: '이름',
          accessor: 'userNm',
        },
        {
          Header: '권한',
          accessor: 'authNm',
        },
        {
          Header: '등록자',
          accessor: 'rgstId',
        },
        {
          Header: '등록일',
          accessor: 'rgstDt',
        },
        {
          id: 'editButton',
          Header: () => (
            <>
            </>
          ),
          Cell: ({ row }) => (
            <UserEditablePopup user={row.original}
                              dataReloadFunc={dataReloadFunc}
                              auths={auths}>
              <div>
                <button className="table-search-submit btn btn-info">수정</button>
              </div>
            </UserEditablePopup>
          ),
        },
        {
          id: 'pwdButton',
          Header: () => (
            <>
            </>
          ),
          Cell: ({ row }) => (
            <PwdEditablePopup user={row.original} 
                              dataReloadFunc={dataReloadFunc}>
              <div>
                <button className="table-search-submit btn btn-info">비밀번호 변경</button>
              </div>
            </PwdEditablePopup>
          ),
        },
        {
          id: 'deleteButton',
          Header: () => (
            <>
            </>
          ),
          Cell: ({ row }) => (
            <div>
              <button className="table-search-submit btn btn-info" 
                      onClick={() => {deleteFunc(row.original.userIdx)}}>
                삭제
              </button>
            </div>
          ),
        },
      ],
    },
  ];

  return columns;
};